import { store } from '../../../../resources/frontend/js/store/index';

/**
 * Calculate the quiz progress percentage
 * @returns {number}
 * @param {number} totalQuestions
 */

export function calculateQuizProgress(totalQuestions) {
    const formStep = store.state.form.attributes.step;
    const isContinuousFlow = store.state.quiz.continuousFlow;
    const questionCount = store.state.quiz.questionCount;

    if (isContinuousFlow) {
        const adjustedCount = questionCount + (formStep - 2);
        return Math.round((adjustedCount / totalQuestions) * 100);
    }

    return Math.round(((questionCount - 1) / totalQuestions) * 100);
}